export const ABOUT_US = [
  // {
  //     title: 'mission',
  //     link: '/',
  // },
  // {
  //     title: 'team',
  //     link: '/',
  // },
  {
    title: "blog",
    link: "/blog"
  },
  {
    title: "team",
    link: "/team"
  },
  // {
  //     title: 'forCities',
  //     link: '/',
  // },
  {
    title: "workAt",
    link: "/vacancies"
  },
  {
    title: "press",
    link: "/press"
  },
  {
    title: "mission",
    link: "/mission"
  },
  {
    title: "partners",
    link: "/partners"
  }
];

export const FOR_HOSTS = [
  {
    title: "register",
    link: "/register"
  },
  {
    title: "howDoesItWork",
    link: "/hospita"
  },
  {
    title: "experienceWithOthers",
    link: "/blog"
  },
  {
    title: "faq",
    link: "/faq"
  }
];

export const FOR_STUDENTS = [
  {
    title: "register",
    link: "/register"
  },
  {
    title: "howDoesItWork",
    link: "/students"
  },
  {
    title: "experienceWithOthers",
    link: "/blog"
  },
  {
    title: "faq",
    link: "/faq"
  }
];

export const SUPPORT = [
  {
    title: "faq",
    link: "/faq"
  },
  {
    title: "contact",
    link: "/contact"
  },
  {
    title: "jobs",
    link: "/vacancies"
  },
  {
    title: "press",
    link: "/press"
  }
  // {
  //     title: 'partners',
  //     link: '/',
  // },
];

export const LEGAL = [
  // {
  //     title: 'teamConditions',
  //     link: '/',
  // },
  {
    title: "privacy",
    link: "/privacy"
  },
  {
    title: "cookies",
    link: "/cookies"
  },
  {
    title: "contactdetails",
    link: "/contactdetails"
  }
];
